export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    title: '同步的订单编号',
    field: 'syncOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'receiveTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '接收时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'syncStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '同步结果确认状态',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'syncStatus' },
  },
  {
    field: 'syncTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '同步时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
